import * as React from 'react';

export default function Spinner(){
    return <i className="fa fa-circle-o-notch fa-spin"></i>;
}